import { z } from "zod";

export const CredentialsSchema = z.object({
  email: z
    .string({ required_error: "El email es obligatorio" })
    .min(1, "El email es obligatorio")
    .email("El email no tiene un formato válido"),
  password: z
    .string({ required_error: "La contraseña es obligatoria" })
    .min(8, "La contraseña debe tener al menos 8 caracteres"),
});

export type CredentialsInput = z.infer<typeof CredentialsSchema>;

export const TotpCodeSchema = z.object({
  code: z
    .string({ required_error: "El código es obligatorio" })
    .regex(/^\d{6}$/, "Ingresa los 6 dígitos del código"),
});

export type TotpCodeInput = z.infer<typeof TotpCodeSchema>;
